import React, { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';
import './HistorialLotesModal.css';

const HistorialNovedadesTransitoModal = ({ isOpen, onClose, transitoId = null, transitoName = null, transitosList = [] }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedTransitoFilter, setSelectedTransitoFilter] = useState(transitoId || 'todos');
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('todos');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [processingId, setProcessingId] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedTransitoFilter(transitoId || 'todos');
      fetchHistory();
    }
  }, [isOpen, transitoId]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();
      const currentTransito = selectedTransitoFilter !== 'todos' ? selectedTransitoFilter : (transitoId || 'todos');
      if (currentTransito && currentTransito !== 'todos') {
        queryParams.append('transito_id', currentTransito);
      }
      if (selectedStatusFilter && selectedStatusFilter !== 'todos') {
        queryParams.append('estado', selectedStatusFilter);
      }
      if (search) {
        queryParams.append('search', search);
      }
      if (startDate) {
        queryParams.append('start_date', startDate);
      }
      if (endDate) {
        queryParams.append('end_date', endDate);
      }

      const res = await axios.get(`/api/transitos/novedades/historial/all?${queryParams.toString()}`);
      setHistory(res.data || []);
    } catch (err) {
      console.error('Error al cargar historial de novedades de tránsito:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchHistory();
  };

  const handleFinalizarNovedad = async (historialItem) => {
    if (!window.confirm(`¿Confirmas que la novedad "${historialItem.novedad}" para el tránsito ${historialItem.transito_name} ha sido solucionada/finalizada?`)) return;

    try {
      setProcessingId(historialItem.id);
      await axios.put(`/api/transitos/novedades/historial/${historialItem.id}/finalizar`);
      alert('✅ Novedad finalizada exitosamente.');
      fetchHistory();
    } catch (err) {
      console.error('Error al finalizar novedad:', err);
      alert('❌ Error al finalizar novedad: ' + (err.response?.data?.message || err.message));
    } finally {
      setProcessingId(null);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleString('es-CO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const calculateDuration = (startStr, endStr) => {
    if (!startStr) return 'N/A';
    const start = new Date(startStr);
    const end = endStr ? new Date(endStr) : new Date();
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return 'N/A';
    const diffMs = end.getTime() - start.getTime();
    if (diffMs < 0) return '0m';

    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days}d ${hours % 24}h`;
    } else if (hours > 0) {
      return `${hours}h ${minutes % 60}m`;
    } else {
      return `${minutes}m`;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="historial-modal-overlay">
      <div className="historial-modal-container" style={{ maxWidth: '1100px', width: '95%' }}>
        <div className="historial-modal-header">
          <div>
            <h2>📜 Bitácora e Historial de Novedades de Tránsito</h2>
            <p className="historial-subtitle">
              {transitoName ? `Mostrando bitácora de: ${transitoName}` : 'Registro histórico de novedades e incidencias por Organismo de Tránsito'}
            </p>
          </div>
          <button className="historial-close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleFilterSubmit} className="historial-modal-toolbar" style={{ flexWrap: 'wrap', gap: '10px', padding: '12px 20px' }}>
          <div style={{ display: 'flex', gap: '8px', flex: '1 1 200px' }}>
            <input
              type="text"
              placeholder="🔍 Buscar texto de novedad o usuario..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="historial-search-input"
              style={{ flex: 1 }}
            />
          </div>

          {!transitoId && (
            <select
              value={selectedTransitoFilter}
              onChange={(e) => setSelectedTransitoFilter(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
            >
              <option value="todos">🏛️ Todos los Tránsitos</option>
              {transitosList.map(t => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
          )}

          <select
            value={selectedStatusFilter}
            onChange={(e) => setSelectedStatusFilter(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
          >
            <option value="todos">📋 Todos los Estados</option>
            <option value="activa">🚨 Activa</option>
            <option value="finalizada">✅ Finalizada</option>
          </select>

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
            title="Fecha inicio"
          />

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
            title="Fecha fin"
          />

          <button type="submit" className="historial-btn-search">Filtrar</button>
          <button type="button" onClick={fetchHistory} className="historial-btn-refresh">🔄 Actualizar</button>
        </form>

        <div className="historial-modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          {loading ? (
            <div className="historial-loading">⏳ Cargando bitácora de novedades...</div>
          ) : history.length === 0 ? (
            <div className="historial-no-data">
              📭 No hay registros en el historial de novedades para los filtros seleccionados.
            </div>
          ) : (
            <table className="historial-table">
              <thead>
                <tr>
                  <th># ID / Inicio</th>
                  <th>Tránsito</th>
                  <th>Novedad / Incidencia Reportada</th>
                  <th>Registrado Por</th>
                  <th>Estado</th>
                  <th>Fecha Fin / Duración</th>
                  <th style={{ textAlign: 'center' }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {history.map((item) => {
                  const isActiva = item.estado === 'activa';
                  return (
                    <tr key={item.id}>
                      <td>
                        <strong>#{item.id}</strong>
                        <div className="historial-date">{formatDate(item.fecha_inicio || item.created_at)}</div>
                      </td>
                      <td>
                        <strong style={{ color: '#1e293b' }}>🏛️ {item.transito_name}</strong>
                      </td>
                      <td style={{ maxWidth: '350px' }}>
                        <div style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          color: '#334155',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                          lineHeight: '1.4'
                        }}>
                          {item.novedad}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontWeight: '600', fontSize: '12px' }}>
                          👤 {item.usuario_nombre || 'Sistema'}
                        </div>
                      </td>
                      <td>
                        <span
                          className="historial-badge"
                          style={{
                            background: isActiva ? '#fef3c7' : '#f1f5f9',
                            color: isActiva ? '#b45309' : '#475569',
                            border: isActiva ? '1px solid #fde68a' : '1px solid #e2e8f0',
                            fontWeight: '800'
                          }}
                        >
                          {isActiva ? '🚨 ACTIVA' : '✅ FINALIZADA'}
                        </span>
                      </td>
                      <td>
                        {isActiva ? (
                          <div style={{ fontSize: '12px', color: '#d97706', fontWeight: '700' }}>
                            En curso ({calculateDuration(item.fecha_inicio || item.created_at, null)})
                          </div>
                        ) : (
                          <div>
                            <div style={{ fontSize: '12px', fontWeight: '600', color: '#059669' }}>
                              {formatDate(item.fecha_fin)}
                            </div>
                            <div style={{ fontSize: '11px', color: '#64748b' }}>
                              Duración: {calculateDuration(item.fecha_inicio || item.created_at, item.fecha_fin)}
                            </div>
                          </div>
                        )}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {isActiva ? (
                          <button
                            disabled={processingId === item.id}
                            onClick={() => handleFinalizarNovedad(item)}
                            style={{
                              background: '#059669',
                              color: '#ffffff',
                              border: 'none',
                              padding: '6px 12px',
                              borderRadius: '6px',
                              fontSize: '11px',
                              fontWeight: '700',
                              cursor: 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              boxShadow: '0 1px 3px rgba(5, 150, 105, 0.2)'
                            }}
                            title="Marcar esta novedad como finalizada"
                          >
                            {processingId === item.id ? '⏳ Finalizando...' : '✓ Finalizar Novedad'}
                          </button>
                        ) : (
                          <span style={{ fontSize: '12px', color: '#94a3b8' }}>—</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistorialNovedadesTransitoModal;
